// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--c3da5","hollow":"styles-module--hollow--143ed","fakeTransparency":"styles-module--fake-transparency--e1743"};